import "../styles/cards.scss";
import { useEffect, useRef } from "react";

export function HomeCard4(props) {
    const main = useRef(null)
    const arr1 = useRef(null)
    const arr2 = useRef(null)
    useEffect(() => {
        if(props.active[props.num]){
            main.current.style.opacity = 1
            arr1.current.style.display = "flex"
            arr2.current.style.display = "flex"
        }else{
            main.current.style.opacity = 0
            arr1.current.style.display = "none"
            arr2.current.style.display = "none"
        }
    }, [props.active])
    return (
        <div className="homeCard4" ref={main}>
            <div className="arrow" ref={arr1} onClick={props.right}>&#8592;</div>
            <div className="main">
                <img src={props.img} />
                <div className="homeCard4Text"> {props.text}</div>
                <div className="homeCard4Name bold"> {props.name}</div>
            </div>
            <div className="arrow" ref={arr2} onClick={props.left}>&#8594;</div>
        </div>
    );
}
